export default {
    meta: {
        title: '机会点详情',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
